import { render, staticRenderFns } from "./SlrcPD_Total.vue?vue&type=template&id=001955e0"
import script from "./SlrcPD_Total.vue?vue&type=script&lang=js"
export * from "./SlrcPD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports